import React, { useContext } from 'react';
import classNames from 'classnames';
import DataRoomEmptyImage from 'assets/images/data-room-empty-image.webp';
import { useTranslation } from 'react-i18next';
import ResolveImage from 'components/ResolveImage';
import { Link } from 'react-router-dom';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';

import './EmptyState.styles.scss';

type EmptyStateProps = {
  className?: string;
};

const EmptyState: React.FC<EmptyStateProps> = (props) => {
  const { className } = props;

  const { doesntHaveAccess } = useContext(DataRoomContext);

  const { t } = useTranslation();

  const classes = classNames('empty-state', className);

  return (
    <div className={classes}>
      <ResolveImage
        src={DataRoomEmptyImage}
        asIllustration
        alt="No requests yet."
      />
      <p>{t('requestDocumentsForThisDeal')}</p>
      <p>{t('trackWhatHasBeenProvided')}</p>

      {!doesntHaveAccess && (
        <Link to="../create" className="ncoded-button ncoded-button--solid">
          {t('createFileRequest')}
        </Link>
      )}
    </div>
  );
};

export default EmptyState;
